import React, { useState } from 'react';
import Popup from './Popup';
import CmsContentReference from '../../cms/cmp/CmsContentReference';
import { IContentRef } from '../../cms/interfaces/IContentRef';
import useCookie from 'react-use-cookie';
import FormContextProvider from '../../context/FormContextProvider';
import SHSwitch from '../form/SHSwitch';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

interface Props {
    content: IContentRef
}
const CookieConsent : React.FC<Props> = ({content}) => {
    const {t} = useTranslation('common');
    const [consentFunctional, setConsentFunctional] = useCookie('consent_functional', '0');
    const [, setConsentAnalytics, removeConsentAnalytics] = useCookie('consent_analytics', '0');
    const [cookieBannerOpen, setCookieBannerOpen] = useState(consentFunctional === '0');

    return <>
        <Popup key={`cookie_popup_${cookieBannerOpen}`} open={cookieBannerOpen}>
        <FormContextProvider name="cookieConsent" defaultValues={{consentFunctional: true, consentAnalytics: true}} onSubmit={(data) => {
                console.log("COOKIE CONSENT", data);
                setConsentFunctional('1');
                if(data?.consentAnalytics === true) {
                    setConsentAnalytics('1');
                    window.location.reload();
                }
                else {
                    removeConsentAnalytics();
                    window.location.reload();
                }
                setCookieBannerOpen(false);
            }
        }>
            <CmsContentReference {...content} />
            <Box >
                <SHSwitch name='consentFunctional' label={t('common.cookie.functional.description')} disabled />
            </Box>
            <Box>
                <SHSwitch name='consentAnalytics' label={t('common.cookie.analytics.description')} />
            </Box>
            <Box sx={{margin: '1em 0', fontSize: '0.8em'}}>
                <Link to={t('common.link.dataprotection.href')}>{t('common.link.dataprotection.text')}</Link>
            </Box>
            <Button name='submitConsent' type='submit' variant="contained">{t('common.cookie.submit.label')}</Button>
        </FormContextProvider>
        </Popup>
    </>
}

export default CookieConsent;